export default function auth({ to, next, router }) {
  if (!localStorage.getItem('token') && to.name !== 'login') {
    return router.push({ name: 'login' });
  }
  if (localStorage.getItem('token') && to.name === 'login') {
    return router.push('/');
  }
  return next();
}
